// extracted by mini-css-extract-plugin
export default {"line":"fJp7h2nWgOM_oaTOxqDg","headingContainer":"gpUZdXzr3MydLeQIqM9a"};